import { DataLoader } from 'src/app/services/data-loader/data-loader';

export const createCase8 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.emitter.emit({
            data: [
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-11T00:00:00.000Z',
                    cnt_fail: 1,
                    cnt_fail_users: 1,
                    cnt_all: 17,
                    cnt_users: 16,
                    failure_rate: 0.058823529411764705,
                    failure_rate_users: 0.0625,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-12T00:00:00.000Z',
                    cnt_fail: 5,
                    cnt_fail_users: 5,
                    cnt_all: 22,
                    cnt_users: 20,
                    failure_rate: 0.22727272727272727,
                    failure_rate_users: 0.25,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-13T00:00:00.000Z',
                    cnt_fail: 22,
                    cnt_fail_users: 10,
                    cnt_all: 47,
                    cnt_users: 30,
                    failure_rate: 0.46808510638297873,
                    failure_rate_users: 0.3333333333333333,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-15T00:00:00.000Z',
                    cnt_fail: 2,
                    cnt_fail_users: 2,
                    cnt_all: 23,
                    cnt_users: 19,
                    failure_rate: 0.08695652173913043,
                    failure_rate_users: 0.10526315789473684,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-16T00:00:00.000Z',
                    cnt_fail: 42,
                    cnt_fail_users: 23,
                    cnt_all: 270,
                    cnt_users: 197,
                    failure_rate: 0.15555555555555556,
                    failure_rate_users: 0.116751269035533,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-17T00:00:00.000Z',
                    cnt_fail: 90,
                    cnt_fail_users: 53,
                    cnt_all: 480,
                    cnt_users: 371,
                    failure_rate: 0.1875,
                    failure_rate_users: 0.14285714285714285,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-18T00:00:00.000Z',
                    cnt_fail: 49,
                    cnt_fail_users: 36,
                    cnt_all: 311,
                    cnt_users: 238,
                    failure_rate: 0.15755627009646303,
                    failure_rate_users: 0.15126050420168066,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-19T00:00:00.000Z',
                    cnt_fail: 26,
                    cnt_fail_users: 14,
                    cnt_all: 81,
                    cnt_users: 67,
                    failure_rate: 0.32098765432098764,
                    failure_rate_users: 0.208955223880597,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-20T00:00:00.000Z',
                    cnt_fail: 6,
                    cnt_fail_users: 5,
                    cnt_all: 48,
                    cnt_users: 43,
                    failure_rate: 0.125,
                    failure_rate_users: 0.11627906976744186,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-21T00:00:00.000Z',
                    cnt_fail: 1,
                    cnt_fail_users: 1,
                    cnt_all: 61,
                    cnt_users: 53,
                    failure_rate: 0.01639344262295082,
                    failure_rate_users: 0.018867924528301886,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-22T00:00:00.000Z',
                    cnt_fail: 10,
                    cnt_fail_users: 7,
                    cnt_all: 69,
                    cnt_users: 58,
                    failure_rate: 0.14492753623188406,
                    failure_rate_users: 0.1206896551724138,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-23T00:00:00.000Z',
                    cnt_fail: 11,
                    cnt_fail_users: 8,
                    cnt_all: 64,
                    cnt_users: 51,
                    failure_rate: 0.171875,
                    failure_rate_users: 0.1568627450980392,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-24T00:00:00.000Z',
                    cnt_fail: 11,
                    cnt_fail_users: 6,
                    cnt_all: 68,
                    cnt_users: 48,
                    failure_rate: 0.16176470588235295,
                    failure_rate_users: 0.125,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-25T00:00:00.000Z',
                    cnt_fail: 17,
                    cnt_fail_users: 8,
                    cnt_all: 81,
                    cnt_users: 66,
                    failure_rate: 0.20987654320987653,
                    failure_rate_users: 0.12121212121212122,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-26T00:00:00.000Z',
                    cnt_fail: 10,
                    cnt_fail_users: 9,
                    cnt_all: 83,
                    cnt_users: 60,
                    failure_rate: 0.12048192771084337,
                    failure_rate_users: 0.15,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-27T00:00:00.000Z',
                    cnt_fail: 5,
                    cnt_fail_users: 4,
                    cnt_all: 69,
                    cnt_users: 58,
                    failure_rate: 0.07246376811594203,
                    failure_rate_users: 0.06896551724137931,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-28T00:00:00.000Z',
                    cnt_fail: 29,
                    cnt_fail_users: 7,
                    cnt_all: 92,
                    cnt_users: 59,
                    failure_rate: 0.31521739130434784,
                    failure_rate_users: 0.11864406779661017,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-29T00:00:00.000Z',
                    cnt_fail: 41,
                    cnt_fail_users: 17,
                    cnt_all: 122,
                    cnt_users: 78,
                    failure_rate: 0.3360655737704918,
                    failure_rate_users: 0.21794871794871795,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-30T00:00:00.000Z',
                    cnt_fail: 10,
                    cnt_fail_users: 6,
                    cnt_all: 53,
                    cnt_users: 40,
                    failure_rate: 0.18867924528301888,
                    failure_rate_users: 0.15,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-10-31T00:00:00.000Z',
                    cnt_fail: 7,
                    cnt_fail_users: 4,
                    cnt_all: 78,
                    cnt_users: 61,
                    failure_rate: 0.08974358974358974,
                    failure_rate_users: 0.06557377049180328,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-11-01T00:00:00.000Z',
                    cnt_fail: 7,
                    cnt_fail_users: 4,
                    cnt_all: 70,
                    cnt_users: 56,
                    failure_rate: 0.1,
                    failure_rate_users: 0.07142857142857142,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-11-02T00:00:00.000Z',
                    cnt_fail: 3,
                    cnt_fail_users: 3,
                    cnt_all: 60,
                    cnt_users: 54,
                    failure_rate: 0.05,
                    failure_rate_users: 0.05555555555555555,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-11-03T00:00:00.000Z',
                    cnt_fail: 17,
                    cnt_fail_users: 11,
                    cnt_all: 73,
                    cnt_users: 58,
                    failure_rate: 0.2328767123287671,
                    failure_rate_users: 0.1896551724137931,
                },
                {
                    split_group: 'App Store, 3.2.400',
                    datetime: '2025-11-04T00:00:00.000Z',
                    cnt_fail: 2,
                    cnt_fail_users: 2,
                    cnt_all: 16,
                    cnt_users: 12,
                    failure_rate: 0.125,
                    failure_rate_users: 0.16666666666666666,
                },
                {
                    split_group: 'Google Play, 3.2.300',
                    datetime: '2025-10-04T00:00:00.000Z',
                    cnt_fail: 18,
                    cnt_fail_users: 8,
                    cnt_all: 37,
                    cnt_users: 23,
                    failure_rate: 0.4864864864864865,
                    failure_rate_users: 0.34782608695652173,
                },
                {
                    split_group: 'Google Play, 3.2.300',
                    datetime: '2025-10-05T00:00:00.000Z',
                    cnt_fail: 7,
                    cnt_fail_users: 2,
                    cnt_all: 22,
                    cnt_users: 15,
                    failure_rate: 0.3181818181818182,
                    failure_rate_users: 0.13333333333333333,
                },
                {
                    split_group: 'Google Play, 3.2.300',
                    datetime: '2025-10-06T00:00:00.000Z',
                    cnt_fail: 20,
                    cnt_fail_users: 7,
                    cnt_all: 45,
                    cnt_users: 29,
                    failure_rate: 0.4444444444444444,
                    failure_rate_users: 0.2413793103448276,
                },
                {
                    split_group: 'Google Play, 3.2.300',
                    datetime: '2025-10-07T00:00:00.000Z',
                    cnt_fail: 4,
                    cnt_fail_users: 4,
                    cnt_all: 46,
                    cnt_users: 39,
                    failure_rate: 0.08695652173913043,
                    failure_rate_users: 0.10256410256410256,
                },
                {
                    split_group: 'Google Play, 3.2.300',
                    datetime: '2025-10-08T00:00:00.000Z',
                    cnt_fail: 1,
                    cnt_fail_users: 1,
                    cnt_all: 35,
                    cnt_users: 33,
                    failure_rate: 0.02857142857142857,
                    failure_rate_users: 0.030303030303030304,
                },
                {
                    split_group: 'Google Play, 3.2.300',
                    datetime: '2025-10-09T00:00:00.000Z',
                    cnt_fail: 1,
                    cnt_fail_users: 1,
                    cnt_all: 17,
                    cnt_users: 17,
                    failure_rate: 0.058823529411764705,
                    failure_rate_users: 0.058823529411764705,
                },
                {
                    split_group: 'Google Play, 3.2.300',
                    datetime: '2025-10-16T00:00:00.000Z',
                    cnt_fail: 1,
                    cnt_fail_users: 1,
                    cnt_all: 3,
                    cnt_users: 2,
                    failure_rate: 0.3333333333333333,
                    failure_rate_users: 0.5,
                },
                {
                    split_group: 'Google Play, 3.2.300',
                    datetime: '2025-10-17T00:00:00.000Z',
                    cnt_fail: 1,
                    cnt_fail_users: 1,
                    cnt_all: 3,
                    cnt_users: 3,
                    failure_rate: 0.3333333333333333,
                    failure_rate_users: 0.3333333333333333,
                },
                {
                    split_group: 'Google Play, 3.2.300',
                    datetime: '2025-10-30T00:00:00.000Z',
                    cnt_fail: 3,
                    cnt_fail_users: 1,
                    cnt_all: 5,
                    cnt_users: 2,
                    failure_rate: 0.6,
                    failure_rate_users: 0.5,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-08T00:00:00.000Z',
                    cnt_fail: 3,
                    cnt_fail_users: 2,
                    cnt_all: 28,
                    cnt_users: 26,
                    failure_rate: 0.10714285714285714,
                    failure_rate_users: 0.07692307692307693,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-09T00:00:00.000Z',
                    cnt_fail: 11,
                    cnt_fail_users: 6,
                    cnt_all: 65,
                    cnt_users: 53,
                    failure_rate: 0.16923076923076924,
                    failure_rate_users: 0.11320754716981132,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-10T00:00:00.000Z',
                    cnt_fail: 15,
                    cnt_fail_users: 14,
                    cnt_all: 99,
                    cnt_users: 87,
                    failure_rate: 0.15151515151515152,
                    failure_rate_users: 0.16091954022988506,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-11T00:00:00.000Z',
                    cnt_fail: 27,
                    cnt_fail_users: 12,
                    cnt_all: 113,
                    cnt_users: 85,
                    failure_rate: 0.23893805309734514,
                    failure_rate_users: 0.1411764705882353,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-12T00:00:00.000Z',
                    cnt_fail: 35,
                    cnt_fail_users: 13,
                    cnt_all: 136,
                    cnt_users: 103,
                    failure_rate: 0.25735294117647056,
                    failure_rate_users: 0.1262135922330097,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-13T00:00:00.000Z',
                    cnt_fail: 41,
                    cnt_fail_users: 17,
                    cnt_all: 118,
                    cnt_users: 84,
                    failure_rate: 0.3474576271186441,
                    failure_rate_users: 0.20238095238095238,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-14T00:00:00.000Z',
                    cnt_fail: 29,
                    cnt_fail_users: 17,
                    cnt_all: 120,
                    cnt_users: 97,
                    failure_rate: 0.24166666666666667,
                    failure_rate_users: 0.17525773195876287,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-15T00:00:00.000Z',
                    cnt_fail: 13,
                    cnt_fail_users: 10,
                    cnt_all: 91,
                    cnt_users: 81,
                    failure_rate: 0.14285714285714285,
                    failure_rate_users: 0.12345679012345678,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-16T00:00:00.000Z',
                    cnt_fail: 155,
                    cnt_fail_users: 101,
                    cnt_all: 748,
                    cnt_users: 591,
                    failure_rate: 0.2072192513368984,
                    failure_rate_users: 0.17089678510998307,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-17T00:00:00.000Z',
                    cnt_fail: 165,
                    cnt_fail_users: 126,
                    cnt_all: 1113,
                    cnt_users: 906,
                    failure_rate: 0.14824797843665768,
                    failure_rate_users: 0.1390728476821192,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-18T00:00:00.000Z',
                    cnt_fail: 80,
                    cnt_fail_users: 50,
                    cnt_all: 511,
                    cnt_users: 404,
                    failure_rate: 0.15655577299412915,
                    failure_rate_users: 0.12376237623762376,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-19T00:00:00.000Z',
                    cnt_fail: 39,
                    cnt_fail_users: 17,
                    cnt_all: 184,
                    cnt_users: 157,
                    failure_rate: 0.21195652173913043,
                    failure_rate_users: 0.10828025477707007,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-20T00:00:00.000Z',
                    cnt_fail: 40,
                    cnt_fail_users: 19,
                    cnt_all: 188,
                    cnt_users: 142,
                    failure_rate: 0.2127659574468085,
                    failure_rate_users: 0.13380281690140844,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-21T00:00:00.000Z',
                    cnt_fail: 29,
                    cnt_fail_users: 19,
                    cnt_all: 150,
                    cnt_users: 128,
                    failure_rate: 0.19333333333333333,
                    failure_rate_users: 0.1484375,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-22T00:00:00.000Z',
                    cnt_fail: 45,
                    cnt_fail_users: 23,
                    cnt_all: 154,
                    cnt_users: 123,
                    failure_rate: 0.2922077922077922,
                    failure_rate_users: 0.18699186991869918,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-23T00:00:00.000Z',
                    cnt_fail: 39,
                    cnt_fail_users: 17,
                    cnt_all: 130,
                    cnt_users: 94,
                    failure_rate: 0.3,
                    failure_rate_users: 0.18085106382978725,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-24T00:00:00.000Z',
                    cnt_fail: 13,
                    cnt_fail_users: 9,
                    cnt_all: 106,
                    cnt_users: 93,
                    failure_rate: 0.12264150943396226,
                    failure_rate_users: 0.0967741935483871,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-25T00:00:00.000Z',
                    cnt_fail: 45,
                    cnt_fail_users: 22,
                    cnt_all: 137,
                    cnt_users: 104,
                    failure_rate: 0.3284671532846715,
                    failure_rate_users: 0.21153846153846154,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-26T00:00:00.000Z',
                    cnt_fail: 29,
                    cnt_fail_users: 15,
                    cnt_all: 132,
                    cnt_users: 105,
                    failure_rate: 0.2196969696969697,
                    failure_rate_users: 0.14285714285714285,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-27T00:00:00.000Z',
                    cnt_fail: 37,
                    cnt_fail_users: 17,
                    cnt_all: 150,
                    cnt_users: 113,
                    failure_rate: 0.24666666666666667,
                    failure_rate_users: 0.1504424778761062,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-28T00:00:00.000Z',
                    cnt_fail: 17,
                    cnt_fail_users: 13,
                    cnt_all: 135,
                    cnt_users: 124,
                    failure_rate: 0.1259259259259259,
                    failure_rate_users: 0.10483870967741936,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-29T00:00:00.000Z',
                    cnt_fail: 21,
                    cnt_fail_users: 12,
                    cnt_all: 147,
                    cnt_users: 122,
                    failure_rate: 0.14285714285714285,
                    failure_rate_users: 0.09836065573770492,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-30T00:00:00.000Z',
                    cnt_fail: 19,
                    cnt_fail_users: 10,
                    cnt_all: 129,
                    cnt_users: 114,
                    failure_rate: 0.14728682170542637,
                    failure_rate_users: 0.08771929824561403,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-10-31T00:00:00.000Z',
                    cnt_fail: 33,
                    cnt_fail_users: 14,
                    cnt_all: 120,
                    cnt_users: 93,
                    failure_rate: 0.275,
                    failure_rate_users: 0.15053763440860216,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-11-01T00:00:00.000Z',
                    cnt_fail: 5,
                    cnt_fail_users: 5,
                    cnt_all: 104,
                    cnt_users: 96,
                    failure_rate: 0.04807692307692308,
                    failure_rate_users: 0.052083333333333336,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-11-02T00:00:00.000Z',
                    cnt_fail: 10,
                    cnt_fail_users: 7,
                    cnt_all: 102,
                    cnt_users: 91,
                    failure_rate: 0.09803921568627451,
                    failure_rate_users: 0.07692307692307693,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-11-03T00:00:00.000Z',
                    cnt_fail: 18,
                    cnt_fail_users: 15,
                    cnt_all: 107,
                    cnt_users: 92,
                    failure_rate: 0.16822429906542055,
                    failure_rate_users: 0.16304347826086957,
                },
                {
                    split_group: 'Google Play, 3.2.400',
                    datetime: '2025-11-04T00:00:00.000Z',
                    cnt_fail: 5,
                    cnt_fail_users: 4,
                    cnt_all: 34,
                    cnt_users: 32,
                    failure_rate: 0.14705882352941177,
                    failure_rate_users: 0.125,
                },
            ],
            queryContext: {
                datasourceColumns: [
                    {
                        id: 'ACTIVITY_APP_VERSION',
                        state: {
                            value: {
                                options: [],
                                filterType: 'include',
                            },
                            isFilterApplied: false,
                            isSplitApplied: true,
                        },
                    },
                ],
                settings: {
                    datetimeAggregation: 'day',
                },
            },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
